import { combineReducers } from "redux";

import auth from "./auth";
import jobsSearch from "./jobs-search";
import search from "./search";
import user from "./user";
import paginations from "./paginations";

const rootReducers = combineReducers({
  user,
  auth,
  search,
  jobsSearch,
  paginations,
});

export default rootReducers;
